// extracted by mini-css-extract-plugin
export default {"text":"TextLineAround_text__bfGkp"};